import { render, staticRenderFns } from "./dal-comp-design.vue?vue&type=template&id=3f9812fc"
import script from "./dal-comp-design.vue?vue&type=script&lang=js"
export * from "./dal-comp-design.vue?vue&type=script&lang=js"
import style0 from "./dal-comp-design.vue?vue&type=style&index=0&id=3f9812fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports